import { useQuery, keepPreviousData } from "@tanstack/react-query";
import api from "../utils/axios";
import { API_ROUTES } from "./routes";

export const useGetEmailDeliveryLogsQuery = (params = {}) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_EMAIL_DELIVERY_LOGS, params],
    queryFn: () => api.get(API_ROUTES.GET_EMAIL_DELIVERY_LOGS, { params }),
    placeholderData: keepPreviousData,
  });
  return {
    data: data?.data?.data ?? [],
    pagination: data?.data?.pagination ?? null,
    isPending,
    isFetching,
    isError,
    error,
  };
};

export const useGetEmailDeliveryLogStatsQuery = (params = {}) => {
  const { data, isPending, isFetching, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_EMAIL_DELIVERY_LOG_STATS, params],
    queryFn: () => api.get(API_ROUTES.GET_EMAIL_DELIVERY_LOG_STATS, { params }),
    placeholderData: keepPreviousData,
  });
  return {
    data: data?.data?.data ?? null,
    isPending,
    isFetching,
    isError,
    error,
  };
};

export const useGetEmailDeliveryLogByIdQuery = (id) => {
  const { data, isPending, isError, error } = useQuery({
    queryKey: [API_ROUTES.GET_EMAIL_DELIVERY_LOG_BY_ID, id],
    queryFn: () =>
      api.get(API_ROUTES.GET_EMAIL_DELIVERY_LOG_BY_ID.replace(":id", id)),
    enabled: !!id,
  });
  return { data: data?.data?.data ?? null, isPending, isError, error };
};
